import styled from "styled-components";
import TextContent from "~/componentes/TextContent";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .ColoredFileInput_Container_button {
    margin: 0em 0.5em 0 0;
    height: 2.3em;
  }

  .ColoredFileInput_Container_icons {
    display: flex;
    align-items: center;
    margin-left: 0.5em;

    i {
      color: #7b898c;
      font-size: 1.25em;
    }
  }

  button {

  }
`;

export const FileName = styled(TextContent)`
  font-size: 0.55em;
  height: 100%;
  line-height: 3.8em;
  border: solid 0.3em ${Colors.Color8};
  border-radius: 1.1em;

  width: 100%;
  max-width: 100%;
  padding-left: 0.5em;

  background-color: ${Colors.Color8};
  color: ${Colors.Color7} !important;
`;
